export default __webpack_public_path__ + "static/media/ShieldingImg.aba7011a.jpg";